

exports.__esModule = true;

var _squid = require('squid');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _uiRouter = require('uiRouter');

var _checkout = require('xo-models/src/checkout');

var _fi = require('xo-models/src/fi');

var _index = require('xo-models/src/app/index');

require('./styles');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('xoReviewTopup', {
    tag: 'xo-review-topup',
    template: _template2['default'],
    props: {
        token: {
            type: 'var'
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                walletPreferences: _fi.$WalletPreferences.instance(this.props.token).retrieve(),
                walletPinModel: _index.$TokenizedWalletPinModel.instance(this.props.token).retrieve()
            };
        }
    },

    actions: {
        gotoTopupFunding: function gotoTopupFunding() {
            _uiRouter.$state.go('checkout.review.sidepage.topupFunding');
        },
        gotoTopupAmount: function gotoTopupAmount() {
            _uiRouter.$state.go('checkout.review.sidepage.topupAmount');
        },
        gotoUpdatePin: function gotoUpdatePin() {
            _uiRouter.$state.go('checkout.review.sidepage.updatePin');
        }
    },

    lifecycle: {
        enter: function enter() {
            this.formatCurrency = _squid.formatCurrency;
            this.instrumentIconId = function (name) {
                return _fi.$WalletInstrumentNameMapping.instance().getInstrumentNameNormalized(name);
            };
            (0, _jquery2['default'])('.tokenization').addClass('topup');
        },
        populate: function populate() {
            // Use the user selected topup funding intrument during the flow.
            if (this.models.checkoutSession.selectedTopupFundingSource) {
                this.models.walletPreferences.topup.fundingSource = this.models.checkoutSession.selectedTopupFundingSource;
            }

            var topupFundingSource = this.models.walletPreferences.topup.fundingSource;
            // Pick the first funding instrument in the topup FIs list, if user hasn't selected one already.
            if (!topupFundingSource || !topupFundingSource.instrument_id) {
                this.models.walletPreferences.topup.fundingSource = this.models.checkoutSession.topupFundingSources && this.models.checkoutSession.topupFundingSources[0];
            } else if (!topupFundingSource.name) {
                // Fetch topup funding instrument details from topup FIs list for FI from user wallet preferences.
                this.models.walletPreferences.topup.fundingSource = _squid.$util.find(this.models.checkoutSession.topupFundingSources, function (fs) {
                    return fs.instrument_id === topupFundingSource.instrument_id;
                });
            } else {
                // Do Nothing
            }

            if (!this.models.walletPreferences.topup.amount) {
                this.models.walletPreferences.topup.amount = _squid.$config.topup.topupAmounts[0];
                this.models.walletPreferences.topup.currency = _squid.$config.topup.currency;
            } else if (!this.models.walletPreferences.topup.currency) {
                this.models.walletPreferences.topup.currency = _squid.$config.topup.currency;
            }
        },
        exit: function exit() {
            (0, _jquery2['default'])('.tokenization').removeClass('topup');
        }
    }
});


_squid.$Component;

_squid.$config;

_squid.formatCurrency;

_squid.$util;

_uiRouter.$state;

_checkout.$CheckoutSessionModel;

_fi.$WalletPreferences;

_fi.$WalletInstrumentNameMapping;

_index.$TokenizedWalletPinModel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-member-components/src/review-topup/directive.js
// module id = ./components/xo-member-components/src/review-topup/directive.js
// module chunks = 1